<template>
  <div class="product-container10">
    <app-navigation></app-navigation>
    <section id="product-hero" class="product-hero-section">
      <div class="hero-video-container">
        <video src="https://vlecadblob.blob.core.windows.net/vlecad-website-mp4/Media/Sequence%2002%20(9).mp4" loop="true" muted="true" autoplay="true" playsinline="true" class="hero-background-video"></video>
        <div class="hero-video-overlay"></div>
      </div>
      <div>
        <div class="hero-content-wrapper">
          <div class="hero-badge1">
            <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
              <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <span>{{ $t('product.hero.poweredBy') }}</span>
          </div>
          <h1 class="hero-title">{{ $t('product.hero.title') }}</h1>
          <p class="hero-subtitle">
            <span>{{ $t('product.hero.subtitle') }}</span>
          </p>
          <div class="hero-cta-group1">
            <router-link to="/contactdemo" class="product-thq-btn-elm1 btn btn-lg btn-primary">{{ $t('common.scheduleDemo') }}</router-link>
            <a href="#batch-production" class="product-thq-btn-elm2 btn btn-lg btn-outline">{{ $t('product.hero.ctaFeatures') }}</a>
          </div>
          <div class="hero-trust-indicators1">
            <div class="trust-item1">
              <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <span>{{ $t('product.hero.badges.bg1') }}</span>
            </div>
            <div class="trust-item1">
              <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <span>{{ $t('product.hero.badges.bg2') }}</span>
            </div>
            <div class="trust-item1">
              <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <span>{{ $t('product.hero.badges.bg3') }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div>
      <section id="parametric-design" class="feature-detail-section">
        <div class="feature-detail-container">
          <div class="feature-detail-grid">
            <div class="feature-detail-content">
              <div class="feature-label">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 3v18m-9-9h18"></path>
                    <rect x="3" y="3" rx="2" width="18" height="18"></rect>
                  </g>
                </svg>
                <span>{{ $t('product.parametricDesign.title') }}</span>
              </div>
              <h2 class="section-title">{{ $t('product.parametricDesign.subtitle') }}</h2>
              <p class="section-content">{{ $t('product.parametricDesign.description') }}
                <span v-html="rawf3iu"></span>
              </p>
              <ul class="feature-benefits-list">
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.parametricDesign.features[0]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.parametricDesign.features[1]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.parametricDesign.features[2]') }}</span>
                </li>
                <li>
                  <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.parametricDesign.features[3]') }}</span>
                </li>
              </ul>
            </div>
            <div class="feature-detail-visual">
              <div class="visual-card-stack">
                <img alt="Concentrated man in glasses sitting at wooden table in workshop and holding pencil while creating new object on paper" src="/vlecad_170628_lr_80_sv5_1220-1500w.jpg" class="stack-card stack-card-1"/>
                <div class="stack-overlay"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div>
      <div>
        <div>
          <section id="one-click-cnc" class="feature-reversed feature-detail-section">
            <div class="feature-detail-container">
              <div class="feature-detail-grid">
                <div class="feature-detail-visual">
                  <div class="product-thq-cnc-showcase-elm cnc-showcase">
                    <img alt="CNC machine in action, precisely cutting a wooden panel with sawdust flying." src="/iv%20interior_cnc-300h.jpg" class="product-thq-cnc-main-image-elm cnc-main-image1"/>
                    <div class="cnc-badge">
                      <svg width="32" xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 24 24">
                        <path d="M14 4.1L12 6M5.1 8l-2.9-.8M6 12l-1.9 2M7.2 2.2L8 5.1m1.037 4.59a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z"
                          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      <span>{{ $t('product.oneClickCnc.eyebrow') }}</span>
                    </div>
                  </div>
                </div>
                <div class="feature-detail-content">
                  <div class="feature-label">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <path d="M14 4.1L12 6M5.1 8l-2.9-.8M6 12l-1.9 2M7.2 2.2L8 5.1m1.037 4.59a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    <span>{{ $t('product.oneClickCnc.title') }}</span>
                  </div>
                  <h2 class="section-title">{{ $t('product.oneClickCnc.subtitle') }}</h2>
                  <p class="section-content">
                    <span>{{ $t('product.oneClickCnc.description') }}</span>
                  </p>
                  <div class="process-steps-compact">
                    <div class="step-compact">
                      <div class="step-number"><span>1</span></div>
                      <div class="step-text2">
                        <h3>{{ $t('product.oneClickCnc.steps.step1.title') }}</h3>
                        <p>{{ $t('product.oneClickCnc.steps.step1.description') }}</p>
                      </div>
                    </div>
                    <div class="step-compact">
                      <div class="step-number"><span>2</span></div>
                      <div class="step-text2">
                        <h3>{{ $t('product.oneClickCnc.steps.step2.title') }}</h3>
                        <p>{{ $t('product.oneClickCnc.steps.step2.description') }}</p>
                      </div>
                    </div>
                    <div class="step-compact">
                      <div class="step-number"><span>3</span></div>
                      <div class="step-text2">
                        <h3>{{ $t('product.oneClickCnc.steps.step3.title') }}</h3>
                        <p>{{ $t('product.oneClickCnc.steps.step3.description') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div>
      <section id="labeling-system" class="labeling-section feature-detail-section">
        <div class="feature-detail-container">
          <div class="labeling-split-layout">
            <div class="labeling-content-side">
              <div class="feature-label">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M16.52 7H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10.52a1 1 0 0 0 .78-.375L21 12l-3.7-4.625A1 1 0 0 0 16.52 7"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('product.labeling.title') }}</span>
              </div>
              <h2 class="section-title">{{ $t('product.labeling.subtitle') }}</h2>
              <p class="section-content">
                {{ $t('product.labeling.description') }}
                <span v-html="rawt5t7"></span>
              </p>
              <div class="labeling-features-grid">
                <div class="labeling-feature-card">
                  <div class="labeling-icon">
                    <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 3v18m-9-9h18"></path>
                        <rect x="3" y="3" rx="2" width="18" height="18"></rect>
                      </g>
                    </svg>
                  </div>
                  <h3>{{ $t('product.labeling.features[0].title') }}</h3>
                  <p>{{ $t('product.labeling.features[0].description') }}</p>
                </div>
                <div class="labeling-feature-card">
                  <div class="labeling-icon">
                    <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </div>
                  <h3>{{ $t('product.labeling.features[1].title') }}</h3>
                  <p>{{ $t('product.labeling.features[1].description') }}</p>
                </div>
                <div class="labeling-feature-card">
                  <div class="labeling-icon">
                    <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>
                        <path d="m3.3 7l8.7 5l8.7-5M12 22V12"></path>
                      </g>
                    </svg>
                  </div>
                  <h3>{{ $t('product.labeling.features[2].title') }}</h3>
                  <p>{{ $t('product.labeling.features[2].description') }}</p>
                </div>
                <div class="labeling-feature-card">
                  <div class="labeling-icon">
                    <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24">
                      <path d="M14 4.1L12 6M5.1 8l-2.9-.8M6 12l-1.9 2M7.2 2.2L8 5.1m1.037 4.59a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </div>
                  <h3>{{ $t('product.labeling.features[3].title') }}</h3>
                  <p>{{ $t('product.labeling.features[3].description') }}</p>
                </div>
              </div>
            </div>
            <div class="labeling-visual-side">
              <div class="labeling-image-cluster">
                <img alt="Hands crafting a wooden plank with clamps and tools. A focus on precision woodworking." src="/vlecad_170628_lr_56_sv5_08971-1500w.jpg" class="cluster-main"/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div>
      <section id="batch-production" class="batch-production-section">
        <div class="batch-production-container">
          <div class="batch-header-content">
            <div class="feature-label">
              <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"></path>
                  <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"></path>
                  <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"></path>
                </g>
              </svg>
              <span>{{ $t('product.batchProduction.title') }}</span>
            </div>
            <h2 class="section-title">{{ $t('product.batchProduction.subtitle') }}</h2>
            <p class="section-subtitle">{{ $t('product.batchProduction.description') }}
              <span v-html="rawl1fs"></span>
            </p>
          </div>
          <div class="batch-capabilities-grid">
            <div class="batch-capability-card">
              <div class="capability-image-wrapper">
                <img alt="A close-up shot of a CNC machine operating in a workshop with a technician nearby." src="/20250429_175035%20-%20nesting%20cnc-1500w.jpg"/>
                <div class="capability-overlay">
                  <svg width="40" xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 0 24 24" class="product-icon143">
                    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"></path>
                      <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"></path>
                      <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"></path>
                    </g>
                  </svg>
                </div>
              </div>
              <div class="capability-content">
                <h3>{{ $t('product.batchProduction.features[0].title') }}</h3>
                <p>
                  {{ $t('product.batchProduction.features[0].description') }}
                  <span v-html="rawz93a"></span>
                </p>
                <ul class="capability-list">
                  <li><span>{{ $t('product.batchProduction.features[0].items[0]') }}</span></li>
                  <li><span>{{ $t('product.batchProduction.features[0].items[1]') }}</span></li>
                  <li><span>{{ $t('product.batchProduction.features[0].items[2]') }}</span></li>
                </ul>
              </div>
            </div>
            <div class="batch-capability-card">
              <div class="capability-image-wrapper">
                <img alt="A detailed view of a CNC machine being operated by a person indoors with dim lighting." src="/vlecad-8276-1500w.jpg" />
                <div class="capability-overlay">
                  <svg width="40" xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 0 24 24" class="product-icon148">
                    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M12 3v18m-9-9h18"></path>
                      <rect x="3" y="3" rx="2" width="18" height="18"></rect>
                    </g>
                  </svg>
                </div>
              </div>
              <div class="capability-content">
                <h3>{{ $t('product.batchProduction.features[1].title') }}</h3>
                <p>
                  {{ $t('product.batchProduction.features[1].description') }}
                  <span v-html="rawz93a"></span>
                </p>
                <ul class="capability-list">
                  <li><span>{{ $t('product.batchProduction.features[1].items[0]') }}</span></li>
                  <li><span>{{ $t('product.batchProduction.features[1].items[1]') }}</span></li>
                  <li><span>{{ $t('product.batchProduction.features[1].items[2]') }}</span></li>
                </ul>
              </div>
            </div>
            <div class="batch-capability-card">
              <div class="capability-image-wrapper">
                <img alt="Close-up of a high precision CNC milling tool used for metalworking in industrial settings." src="/vlecad_170628_lr_33_sv5_0608-1500w.jpg"/>
                <div class="capability-overlay">
                  <svg width="40" xmlns="http://www.w3.org/2000/svg" height="40" viewBox="0 0 24 24" class="product-icon152">
                    <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"
                      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </div>
              </div>
              <div class="capability-content">
                <h3>{{ $t('product.batchProduction.features[2].title') }}</h3>
                <p>
                  {{ $t('product.batchProduction.features[2].description') }}
                  <span v-html="rawz93a"></span>
                </p>
                <ul class="capability-list">
                  <li><span>{{ $t('product.batchProduction.features[2].items[0]') }}</span></li>
                  <li><span>{{ $t('product.batchProduction.features[2].items[1]') }}</span></li>
                  <li><span>{{ $t('product.batchProduction.features[2].items[2]') }}</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section id="materials-edges" class="materials-section">
      <div>
        <div class="materials-container">
          <div class="materials-intro">
            <div class="feature-label">
              <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                <path d="m5 12l7-7l7 7m-7 7V5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <span>{{ $t('product.materials.title') }}</span>
            </div>
            <h2 class="section-title">{{ $t('product.materials.subtitle') }}</h2>
            <p class="section-content">
              <span>{{ $t('product.materials.description') }}</span>
            </p>
          </div>
          <div class="materials-showcase-grid">
            <div class="material-showcase-card material-card-large">
              <div class="material-card-header">
                <div class="material-icon-badge">
                  <svg width="32" xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>
                      <path d="m3.3 7l8.7 5l8.7-5M12 22V12"></path>
                    </g>
                  </svg>
                </div>
                <h3>{{ $t('product.materials.panels.title') }}</h3>
              </div>
              <img alt="Close-up of various woodworking tools in a workshop, featuring wood shavings and equipment." src="/vlecad_170628_lr_42_sv5_0686-1500w.jpg" class="material-image"/>
              <ul class="material-features">
                <li>
                  <svg width="18" xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.materials.panels.items[0]') }}</span>
                </li>
                <li>
                  <svg width="18" xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.materials.panels.items[1]') }}</span>
                </li>
                <li>
                  <svg width="18" xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.materials.panels.items[2]') }}</span>
                </li>
              </ul>
            </div>
            <div class="material-showcase-card">
              <div class="material-card-header">
                <div class="material-icon-badge">
                  <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24">
                    <path d="M16.52 7H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10.52a1 1 0 0 0 .78-.375L21 12l-3.7-4.625A1 1 0 0 0 16.52 7"
                      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </div>
                <h3>{{ $t('product.materials.edgebands.title') }}</h3>
              </div>
              <ul class="material-features">
                <li>
                  <svg width="18" xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.materials.edgebands.items[0]') }}</span>
                </li>
                <li>
                  <svg width="18" xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.materials.edgebands.items[1]') }}</span>
                </li>
                <li>
                  <svg width="18" xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.materials.edgebands.items[2]') }}</span>
                </li>
              </ul>
            </div>
            <div class="material-showcase-card">
              <div class="material-card-header">
                <div class="material-icon-badge">
                  <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24">
                    <path d="M5 12h14m-7-7v14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </div>
                <h3>{{ $t('product.materials.pricing.title') }}</h3>
              </div>
              <ul class="material-features">
                <li>
                  <svg width="18" xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.materials.pricing.items[0]') }}</span>
                </li>
                <li>
                  <svg width="18" xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.materials.pricing.items[1]') }}</span>
                </li>
                <li>
                  <svg width="18" xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.materials.pricing.items[2]') }}</span>
                </li>
              </ul>
            </div>
            <div class="material-showcase-card material-card-wide">
              <div class="material-card-header">
                <div class="material-icon-badge">
                  <svg width="28" xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M12 3v18m-9-9h18"></path>
                      <rect x="3" y="3" rx="2" width="18" height="18"></rect>
                    </g>
                  </svg>
                </div>
                <h3>{{ $t('product.materials.orders.title') }}</h3>
              </div>
              <ul class="material-features">
                <li>
                  <svg width="18" xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.materials.orders.items[0]') }}</span>
                </li>
                <li>
                  <svg width="18" xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.materials.orders.items[1]') }}</span>
                </li>
                <li>
                  <svg width="18" xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24">
                    <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span>{{ $t('product.materials.orders.items[2]') }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="hardware-libraries" class="hardware-section">
      <div class="hardware-container">
        <div>
          <div class="hardware-split-layout">
            <div class="hardware-visual-column">
              <div class="hardware-visual-stack">
                <div class="hardware-image-frame">
                  <img alt="Top view of carpentry tools and wooden planks neatly arranged for a project." src="/vlecad_170628_lr_37_sv5_0632-1500w.jpg" />
                </div>
                <div class="hardware-stats-card">
                  <div class="stat-item">
                    <div class="stat-number"><span>3000+</span></div>
                    <div class="stat-label"><span>{{ $t('product.hardware.stats.items') }}</span></div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-number"><span>20+</span></div>
                    <div class="stat-label"><span>{{ $t('product.hardware.stats.brands') }}</span></div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-number"><span>∞</span></div>
                    <div class="stat-label"><span>{{ $t('product.hardware.stats.expandable') }}</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="hardware-content-column">
              <div class="feature-label">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="m16 6l4 14M12 6v14M8 8v12M4 4v16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>{{ $t('product.hardware.title') }}</span>
              </div>
              <h2 class="section-title">{{ $t('product.hardware.subtitle') }}</h2>
              <p class="section-content">{{ $t('product.hardware.description') }}
                <span v-html="rawz81x"></span>
              </p>
              <div class="hardware-category-list">
                <div class="hardware-category-item">
                  <div class="category-icon">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </div>
                  <div class="category-content">
                    <h4>{{ $t('product.hardware.categories.hinges.title') }}</h4>
                    <p>{{ $t('product.hardware.categories.hinges.description') }}</p>
                  </div>
                </div>
                <div class="hardware-category-item">
                  <div class="category-icon">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </div>
                  <div class="category-content">
                    <h4>{{ $t('product.hardware.categories.drawers.title') }}</h4>
                    <p>{{ $t('product.hardware.categories.drawers.description') }}</p>
                  </div>
                </div>
                <div class="hardware-category-item">
                  <div class="category-icon">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </div>
                  <div class="category-content">
                    <h4>{{ $t('product.hardware.categories.lifts.title') }}</h4>
                    <p>{{ $t('product.hardware.categories.lifts.description') }}</p>
                  </div>
                </div>
                <div class="hardware-category-item">
                  <div class="category-icon">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </div>
                  <div class="category-content">
                    <h4>{{ $t('product.hardware.categories.handles.title') }}</h4>
                    <p>{{ $t('product.hardware.categories.handles.description') }}</p>
                  </div>
                </div>
                <div class="hardware-category-item">
                  <div class="category-icon">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </div>
                  <div class="category-content">
                    <h4>{{ $t('product.hardware.categories.connectors.title') }}</h4>
                    <p>{{ $t('product.hardware.categories.connectors.description') }}</p>
                  </div>
                </div>
                <div class="hardware-category-item">
                  <div class="category-icon">
                    <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                      <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </div>
                  <div class="category-content">
                    <h4>{{ $t('product.hardware.categories.custom.title') }}</h4>
                    <p>{{ $t('product.hardware.categories.custom.description') }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div>
      <section id="final-cta" class="final-cta-section1">
        <div class="final-cta-container">
          <div class="cta-content-wrapper">
            <div class="cta-badge">
              <svg width="20" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24">
                <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <span>{{ $t('product.finalCta.title') }}</span>
            </div>
            <h2 class="section-title">{{ $t('product.finalCta.subtitle') }}</h2>
            <p class="section-content">{{ $t('product.finalCta.description') }}
              <span v-html="rawmpgr"></span>
            </p>
            <div class="cta-buttons-row">
              <router-link to="/contactdemo" class="product-thq-btn-elm8 btn btn-xl btn-primary">
                <button @click="scrollToTop">
                  {{ $t('common.scheduleDemo') }}
                </button>
              </router-link>
              <a :href="brochureHref" :download="brochureFilename" class="btn btn-xl btn-outline">
                {{ $t('common.brochure') }}
              </a>
            </div>
            <div class="cta-contact-info">
              <div class="contact-item">
                <span class="contact-label">{{ $t('product.contact.title') }}</span>
                <span class="contact-value">+32 (0)89 81 93 30</span>
              </div>
              <div class="contact-divider"></div>
              <div class="contact-item">
                <span class="contact-label">Email</span>
                <span class="contact-value">info@vlecad.com</span>
              </div>
            </div>
          </div>
          <div class="cta-visual-wrapper">
            <img alt="Carpenter in a workshop drafting plans on a laptop surrounded by tools and woodworking equipment." src="/vlecad_170628_lr_14_sv5_0379-1500w.jpg" class="cta-image"/>
            <a href="https://vlecad.be" target="_blank" rel="noreferrer noopener">
              <div class="product-thq-cta-floating-badge-elm cta-floating-badge">
                <svg width="24" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24">
                  <path d="M20 6L9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>VLECAD® powered</span>
              </div>
            </a>
          </div>
        </div>
      </section>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";

import AppNavigation from "../components/navigation";
import AppFooter from "../components/footer";

export default {
  name: "Product",
  props: {},
  components: {
    AppNavigation,
    AppFooter,
  },
  setup() {
    // Vue 3 migration: move metaInfo into useHead.
    useHead({
      title: "Product - KORPUS by VLECAD®",
      meta: [
        {
          name: "description",
          content:
            "KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.",
        },
        {
          property: "og:title",
          content: "Product - KORPUS by VLECAD®",
        },
        {
          property: "og:description",
          content:
            "KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.",
        },
        {
          property: "og:image",
          content:
            "https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/ebedf48f-c2b5-4ca6-808d-9d940905bddf/993061ae-1787-4b73-9fda-47262adc60d9?org_if_sml=1&force_format=original",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://hospitable-imperfect-heron-qlicxu.teleporthq.app/product",
        },
      ],
    });
  },
  mounted() {
    // Vue 3 migration/security: replace injected scripts with lifecycle hooks.
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px",
    };

    const fadeInObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = "1";
          entry.target.style.transform = "translateY(0)";
        }
      });
    }, observerOptions);

    const featureSections = document.querySelectorAll(
      ".feature-detail-section, .batch-production-section, .materials-section, .hardware-section, .crash-check-section, .final-cta-section"
    );

    featureSections.forEach((section) => {
      section.style.opacity = "0";
      section.style.transform = "translateY(30px)";
      section.style.transition = "opacity 0.8s ease-out, transform 0.8s ease-out";
      fadeInObserver.observe(section);
    });

    const heroSection = document.getElementById("product-hero");
    const heroVideo = document.querySelector(".hero-background-video");

    const handleParallaxScroll = () => {
      const scrolled = window.pageYOffset;
      const heroHeight = heroSection?.offsetHeight || 0;

      if (scrolled < heroHeight) {
        const parallaxSpeed = 0.5;
        if (heroVideo) {
          heroVideo.style.transform = `translateY(${scrolled * parallaxSpeed}px)`;
        }
      }
    };

    if (heroVideo && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      window.addEventListener("scroll", handleParallaxScroll);
    }

    const ctaButtons = document.querySelectorAll(".hero-cta-group .btn-outline");
    ctaButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const parametricSection = document.getElementById("parametric-design");
        if (parametricSection) {
          parametricSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    });

    const statsObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const statNumbers = entry.target.querySelectorAll(".stat-number");
            statNumbers.forEach((stat) => {
              const targetText = stat.textContent;
              if (targetText.includes("+")) {
                const target = parseInt(targetText.replace("+", ""), 10);
                animateCounter(stat, target, "+");
              }
            });
            statsObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    function animateCounter(element, target, suffix = "") {
      let current = 0;
      const increment = target / 50;
      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          element.textContent = target + suffix;
          clearInterval(timer);
        } else {
          element.textContent = Math.floor(current) + suffix;
        }
      }, 30);
    }

    const hardwareStatsCard = document.querySelector(".hardware-stats-card");
    if (hardwareStatsCard) {
      statsObserver.observe(hardwareStatsCard);
    }

    const capabilityCards = document.querySelectorAll(".batch-capability-card");
    capabilityCards.forEach((card) => {
      card.addEventListener("mouseenter", () => {
        card.style.zIndex = "10";
      });

      card.addEventListener("mouseleave", () => {
        card.style.zIndex = "1";
      });
    });

    const bentoCards = document.querySelectorAll(".bento-card");
    const bentoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.style.opacity = "1";
              entry.target.style.transform = "translateY(0)";
            }, index * 100);
            bentoObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    bentoCards.forEach((card) => {
      card.style.opacity = "0";
      card.style.transform = "translateY(20px)";
      card.style.transition = "opacity 0.6s ease-out, transform 0.6s ease-out";
      bentoObserver.observe(card);
    });

    const images = document.querySelectorAll("img[src]");
    images.forEach((img) => {
      img.loading = "lazy";
    });

    this._cleanupProduct = () => {
      fadeInObserver.disconnect();
      statsObserver.disconnect();
      bentoObserver.disconnect();
      window.removeEventListener("scroll", handleParallaxScroll);
    };
  },
  beforeUnmount() {
    if (this._cleanupProduct) {
      this._cleanupProduct();
    }
  },
  computed: {
    brochureLanguageCode() {
      const locale = String(this.$i18n?.locale || "nl")
        .toLowerCase()
        .split("-")[0];
      const languageCodes = {
        nl: "NL",
        fr: "FR",
        en: "EN",
        de: "DE",
      };

      return languageCodes[locale] || "NL";
    },
    brochureFilename() {
      return `Vlecad Brochure 2026 ${this.brochureLanguageCode}.pdf`;
    },
    brochureHref() {
      return encodeURI(`/${this.brochureFilename}`);
    },
  },
  data() {
    return {
      rawblht: " ",
      raw7x8v: " ",
      rawf3iu: " ",
      rawue62: " ",
      rawqx88: " ",
      rawt5t7: " ",
      rawl1fs: " ",
      rawz93a: " ",
      raw5baw: " ",
      rawc8w0: " ",
      rawu953: " ",
      rawvqvr: " ",
      rawd46g: " ",
      rawz81x: " ",
      rawmpgr: " ",
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }    
  }
};
</script>

<style>
@keyframes pulse-badge {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
@keyframes float-accent {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}
* {
  transition: background-color 0.3s var(--animation-curve-primary), color 0.3s var(--animation-curve-primary), border-color 0.3s var(--animation-curve-primary);
}
</style>

<style scoped>
.product-container10 {
  width: 100%;
  display: block;
  min-height: 100vh;
}

.product-container11 {
  display: none;
}

.product-container12 {
  display: contents;
}

.product-container13 {
  display: none;
}

.product-container14 {
  display: contents;
}

.product-container15 {
  display: none;
}

.product-container16 {
  display: contents;
}

.product-thq-btn-elm1 {
  text-decoration: none;
}

.product-thq-btn-elm2 {
  text-decoration: none;
}

.product-thq-btn-elm3 {
  text-decoration: none;
}

.product-thq-cnc-showcase-elm {
  width: 400px;
}

.product-thq-cnc-main-image-elm {
  width: 424px;
  height: 246px;
}

.product-thq-btn-elm4 {
  text-decoration: none;
}

.product-icon143 {
  display: none;
}

.product-icon148 {
  display: none;
}

.product-icon152 {
  display: none;
}

.product-thq-batch-cta-wrapper-elm {
  text-decoration: none;
}

.product-thq-hardware-cta-group-elm {
  display: none;
}

.product-thq-btn-elm8 {
  text-decoration: none;
}

.product-thq-cta-floating-badge-elm {
  text-decoration: none;
}
</style>
